import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import uri from "../../../constants/uri";

const saveAnswerFile = async (file, answerId) => {
	const formData = new FormData();
	formData.append("file", file);
	await client.post(`${uri}/item_attachment/${answerId}`, formData, {
		headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
	});
};

export default saveAnswerFile;
